/// <reference path="./global.d.ts" />
/*!
 * @preserve
 * Detect.js
 * BrowserInfoCollector Frontend JS for dein-ip-check.de (Modul: Main-Script)
 *
 * @author Jens Dutzi <jens.dutzi@tf-network.de>
 * @website http://www.dein-ip-check.de
 * @license Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

// Polyfills hinzuladen
require("./polyfill/intl");
require('es6-promise').polyfill();

// Klassen importieren
import detectSystem from "./System/system";
import detectGeo from "./Geo/geo";

let runOnce=false;

window.onload = () => {
    // Erkennung des Systems/Browser und der installierten Schriften
    if(runOnce === true) {
        console.info('Avoid second detection-run after Cookiebot-Reload');
    } else {
        runOnce=true;
        console.info('Start first detection run');
        detectSystem();
        detectGeo();
    }
};

